module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct1"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contenttoc#t1",
      "id": "c1"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p15.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "txc"
  }, [_c('b', [_c('i', [_vm._v("Don’t bunt. Aim out of the ballpark.")])])]), _vm._v(" "), _c('p', {
    staticClass: "txc"
  }, [_c('b', [_c('i', [_vm._v("Aim for the company of immortals.")])])]), _vm._v(" "), _c('p', {
    staticClass: "aut"
  }, [_vm._v("— David Ogilvy"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#pz15-11",
      "id": "AK"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "href": "#/contenttoc#t2",
      "id": "c2"
    }
  }, [_vm._v("Welcome to the Real World")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("You are about to embark on a job search. To be successful, you must grasp some very important concepts about the real world. By understanding these elementary concepts, you will have a distinct advantage over your peers who may not fully appreciate these realities.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('i', [_vm._v("The Business World")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("First, a company exists to make a profit. Companies make a profit by selling their products or services for more than the costs to produce those products or services. A company will cease to exist if it is not profitable.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Second, a job within a company must either make or save money for the company. If it does not, it will be eliminated. As a college graduate job seeker, you must present your skills in a way to make or save the company money and contribute to the profitability "), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("of the company. If there is no perceived value in hiring you, you will not receive a job offer. Thereafter, your performance on the job must provide value beyond the cost of your employment.")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "h3"
  }, [_c('i', [_vm._v("The Non-Commercial Professional World")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Careers in non-commercial fields have similar realities and value evaluations. As a recent college graduate, you must present your skills and background to further the mission of the organization (governmental agency, public entity, non-profit and so on). Once hired, your job performance must meet or exceed expectations or you are at risk of losing your job.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("These are real-world realities. Too many college graduates fail to understand, let alone truly appreciate, these realities. They believe that every company or organization is nothing but an entity that can afford to give them a job. Clearly understand this concept: All companies must be profitable to survive. All entities in other fields must meet their mission to continue to exist. And, all employers are sensitive to the productivity of their employees. If your productivity (the value you bring as an employee) falls below the cost of having you, or you fail to meet the minimum standards of performance, you will be fired. Sound harsh? Welcome to the real world.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("However, understanding these realities can work to your advantage during your job search. Why? When you understand these real-world realities, you can present yourself to employers by speaking their language. You will be able to sell your abilities in a way that a hiring executive will see value in hiring you. It’s a matter of appealing to the mentality of the hiring executive who can offer you a job. Much of this book is about teaching you how to present yourself in a way that displays your value.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Let’s talk about another reality. Do the “best” qualified college graduates always get the best jobs? No, they don’t. Let me explain: To get a career-level job as a recent college graduate, you must certainly be qualified for the open positions in your field of endeavor. However, with increasing frequency, the college graduates that get the better jobs are those that execute a better job search. In other words, you can out-flank your peers with higher GPA’s and perhaps better experience when you execute a more effective job search.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Realize that employers value initiative, perseverance, work ethic, effort, and a host of other professional characteristics (to be discussed further in the pages that follow). When you execute an efficient, self-motivated job search, you put those professional character traits on display, with your qualifications. You will do better than you think against your competition and perhaps get more job offers by effectively executing a job search better than they do.")])]), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contenttoc#t3",
      "id": "c3"
    }
  }, [_vm._v("How to Use This Book")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("This job search book is written for the motivated college graduate who wants a proven methodology on how to effectively conduct a job search in today’s competitive marketplace.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As you read this book, have a highlighter and a pen available. Study the book and highlight concepts you want to remember. Write in the margins. Fold the page corners. Use a notepad to write down thoughts and to-do’s as they occur to you. Then, after your job search is underway, review this book to stay motivated and on track. Be careful! There are several things during a job search that can cross the line from being productive to just doing busy-work disguised as productivity. Ask yourself: Am I being productive with my time and effort, or am I just doing busy-work, thinking that I am being productive? You’ll know the answer.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('b', [_vm._v("Pay particular attention to the stars")]), _vm._v(" ★ "), _c('b', [_vm._v("throughout the book.")]), _vm._v(" These useful, powerful job search topics or techniques will differentiate you from other recent college graduates and shorten your job search.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Remember that a successful job search is about presenting yourself in a professional manner, engaging in conversations with those that can help and hire you, providing hiring executives and talent acquisition professionals in interviews with your college record, examples of your skills, accomplishments, and character traits. When you do, you heighten your chances of landing job offers for opportunities you want.")]), _vm._v(" "), _c('p', {
    staticClass: "tx2"
  }, [_vm._v("_______________")]), _vm._v(" "), _c('p', {
    staticClass: "fn"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/#AK",
      "id": "pz15-11"
    }
  }, [_vm._v("2")])]), _vm._v(" “David Ogilvy Quotable Quote,” "), _c('i', [_vm._v("Goodreads")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "http://www.goodreads.com/quotes/262108-don-t-bunt-aim-out-of-the-ballpark-aim-for-the",
      "id": "AY4",
      "target": "_blank"
    }
  }, [_vm._v("http://www.goodreads.com/quotes/262108-don-t-bunt-aim-out-of-the-ballpark-aim-for-the")]), _vm._v(" (accessed May 28, 2015).")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a62361a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/frontmatter04.vue
// module id = 75
// module chunks = 0